import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { SessionService } from '@app/core/services/session/session.service';
import { FormField } from '@app/shared/models/field.interface';
import { DatePickerCustomHeaderComponent } from './datepicker-header/datepicker-custom-header.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM'
  }
};

@Component({
  selector: 'vfs-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DatepickerComponent)
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class DatepickerComponent implements OnInit {
  @Input() field: FormField;
  @Input() width = '220px';
  @Input() opened: boolean;
  @Input() startAt: Date | null;
  @Input() startView: 'month' | 'year' | 'multi-year';
  @Output() closedStream = new EventEmitter<void>();
  @Output() monthSelected = new EventEmitter<any>();
  @Output() openedStream = new EventEmitter<void>();
  @Output() yearSelected = new EventEmitter<any>();
  customHeader = DatePickerCustomHeaderComponent;
  // Properties of Datepicker Input
  @Input() matDatepickerFilter: (date: Date) => boolean;
  @Input() max: Date | null;
  @Input() min: Date | null;
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<Date>> = new EventEmitter<MatDatepickerInputEvent<Date>>();
  @Output() dateInput: EventEmitter<MatDatepickerInputEvent<Date>> = new EventEmitter<MatDatepickerInputEvent<Date>>();
  @Input() error: string;
  // No Form
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() hint?: string;
  @Input() formControl: FormControl;
  @Input() required: boolean;
  @Input() tooltip: string;

  @Input() disabled: boolean;
  value: any;

  constructor(protected dateAdapter: DateAdapter<any>, protected sessionService: SessionService) {}

  ngOnInit(): void {
    this.dateAdapter.setLocale(this.sessionService.getLang());
  }

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  closedStreamEvt(evt: void) {
    this.closedStream.emit(evt);
  }

  monthSelectedEvt(evt: any) {
    this.monthSelected.emit(evt);
  }

  openedStreamEvt(evt: void) {
    this.openedStream.emit(evt);
  }

  yearSelectedEvt(evt: any) {
    this.yearSelected.emit(evt);
  }
}
